<template>
  <DashboardStatCard
    title="Outstanding"
    subtitle="Customer balance"
    icon="mdi-cash-clock"
    color="orange"
    :loading="isLoading"
    to="/customer/list"
  >
    {{ amount | currency }}
  </DashboardStatCard>
</template>

<script>
import customerService from "../../service";
import DashboardStatCard from "@/modules/Home/components/DashboardStatCard";

export default {
  components: {
    DashboardStatCard,
  },

  data() {
    return {
      isLoading: true,
      amount: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      customerService.getOutstandingBalance().then((response) => {
        this.amount = response.data;
        this.isLoading = false;
      });
    },
  },
};
</script>